import React from 'react'

const Terms = () => {
    return (
        <p>Terms</p>
    )
}

export default Terms;
